import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const GetAllCardTypeDef = () => get(url.CARD_TYPE_DEF_GET)